import React, { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
import moment from "moment";
import {UpdateorCancelButtons} from "./UpdateorCancelButtons";
import { UrlPath } from "../../../../config/routeConfig";
import { useLocation } from "react-router-dom";
import { insertOrUpdateContactOtherAttributes } from "../../../../config/apiConfig";
import { sbaAxios } from "../../../utils/sbaAxios";
import { SBNotify } from "../../../utils/sbNotify";
import { ContactGeneralAttributes } from "../../../../config/investorConfig";
import { SBADropDown } from "../../../UiComponents/SBADropDown";
import {
  getWebCategoriesAction,
  getWebStatusTypesAction
} from "../../../actions/contactsAction";
import { getEnumeration } from '../../../actions/CommonAction';
import { SBDatePicker } from "../../../UiComponents/SBDatePicker";
import { ToastContainer, toast } from 'react-toastify';

export const OthersEdit = () => {
   
  const dispatch = useDispatch();
  const history = useNavigate();
  const locationData = useLocation();
  const queryParams = new URLSearchParams(locationData.search);
  const paramValue = queryParams.get('ContactTypeId'); 
  useEffect(() => {
    dispatch(getWebCategoriesAction());
      dispatch(getWebStatusTypesAction());
      dispatch(getEnumeration("ContactSource"));
  }, []);

  const Gstate = useSelector((state) => state) || {};
  const webCategories = Gstate?.Contacts?.webCategories || [];
  const webStatusTypes = Gstate?.Contacts?.webStatusTypes || [];
const ContactdataSource = Gstate.enumValues.enumValues || [];
  const contactDetails = locationData.state.OthersData;

  const [loading, setLoading] = useState(true);
  const [webCategory, setWebCategory] = useState(null);
  const [webStatus, setWebStatus] = useState(null);
 const [contactSourcevalue, setcontactSourcevalue] = useState([]);
    useEffect(() => {
        contactDetails && setLoading(false);
        
    }, [contactDetails]);

  const redirectLinkClick = () => {
    history(`${UrlPath.InvestorDetails}${contactDetails.contactId}?ContactTypeId=${paramValue}`, { state: { ActiveContactInfoButton: 3 } });
  };

  const defaultAttributeId = ContactGeneralAttributes.defaultAttributeId;
  const defaultEncrypted = ContactGeneralAttributes.isEncrypted;
  
const [othersState, setOthersState] = useState({
  anniversary: contactDetails.anniversary ? moment(contactDetails.anniversary).format("MM/DD/yyyy") : null,
  spouseName: contactDetails.spouseName || "",
  contactNotes: contactDetails.contactNotes || "",
  contactSource: contactDetails.contactSource || "",
  contactSourceId: contactDetails.contactSourceId || "",
  webUserID: contactDetails.webUserId || "",
  webStatusId: contactDetails.contactWebStatusId || "",
  webStatusTypeId: contactDetails.contactWebStatusTypeId || 1,
  webStatus: contactDetails.contactWebStatusTypeName || "",
  webCategoryId: contactDetails.contactWebCategoryId || 1,
  webCategory: contactDetails.contactWebCategoryName  || "",
  webURL: contactDetails.webUrl || "",

  boardMember: contactDetails.boardMember || "",
  estimatedAnnualIncome: contactDetails.annualIncome || "",
  estimatedAssets: contactDetails.estimateAssest || "",
  modifiedDate: contactDetails.modifiedDate || "",
});

useEffect(() => {
  setWebCategory({ContactWebCategoryId: contactDetails.contactWebCategoryId || 1, ContactWebCategoryName: contactDetails.contactWebCategoryName || "Investor"});
  setWebStatus({ContactWebStatusTypeId: contactDetails.contactWebStatusTypeId || 1, ContactWebStatusTypeName: contactDetails.contactWebStatusTypeName || "Active"});
    if (ContactdataSource) {
        const selectedValue = ContactdataSource
            ?.filter(item => item.EnumName === contactDetails.contactSource)
            .map(item => ({ "EnumValue": item.EnumValue, "EnumName": item.EnumName }))[0];
       
        setcontactSourcevalue(selectedValue)
    }
}, [ContactdataSource]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setOthersState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleDateChange = (date, fieldName) => {
    let formattedDate;

      if (true) {
          formattedDate = date!== null ? moment(date).format("MM/DD/yyyy") : null;
      }
    const updatedState = { ...othersState, [fieldName]: formattedDate };
    setOthersState(updatedState);
  };

  const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    const updatedState = { ...othersState, [name]: checked ? "Yes" : "No" };
    setOthersState(updatedState);
  };

  const handleCategoryDropdown = (e, fieldName) => {
    const Value = e.value.ContactWebCategoryId;
    const updatedState = { ...othersState, [fieldName]: Value };
    const newValue = {ContactWebCategoryName: e.value.ContactWebCategoryName ,ContactWebCategoryId: e.value.ContactWebCategoryId};
      setWebCategory(newValue);
    setOthersState(updatedState);
  };
  
    const handleStatusDropdown = (e, fieldName) => {    
    const Value = e.value.ContactWebStatusTypeId;
    const updatedState = { ...othersState, [fieldName]: Value };
    const newValue = {ContactWebStatusTypeName: e.value.ContactWebStatusTypeName ,ContactWebStatusTypeId: e.value.ContactWebStatusTypeId};
    setWebStatus(newValue);
    setOthersState(updatedState);
    };
    const handleContactDropdown = (e, fieldName) => {    
        const Value = e.value.EnumName;
        const updatedState = { ...othersState, [fieldName]: Value };
        const newValue = { EnumValue: e.value.EnumValue, EnumName: e.value.EnumName };
        setcontactSourcevalue(newValue);
        setOthersState(updatedState);
    };

  const contactOtherAttributes = [];

  const fieldsToInclude = [
    "anniversary",
    "spouse",
    "contactSource",  
    "annualIncome",  
    "estimateAssest",
    "boardMember",
  ];
  
  for (const field of fieldsToInclude) {

      let contactAttributeId;
      let contactAttributeTypeId;
      let contactAttributeTypeValue;
      let isEncrypted;
     
      switch (field) {
        case "anniversary":
          contactAttributeId = contactDetails?.anniversaryAttributeId || defaultAttributeId;
          contactAttributeTypeId = ContactGeneralAttributes.Anniversary;
          contactAttributeTypeValue = othersState.anniversary;
          isEncrypted = contactDetails?.anniversaryIsEncrypted || defaultEncrypted;
          break;
        case "spouse":
          contactAttributeId = contactDetails?.spouseAttributeId || defaultAttributeId;
          contactAttributeTypeId = ContactGeneralAttributes.SpouseName;
          contactAttributeTypeValue = othersState.spouseName;
          isEncrypted = contactDetails?.spouseIsEncrypted || defaultEncrypted;
          break;
        case "contactSource":
          contactAttributeId = contactDetails?.contactSourceAttributeId || defaultAttributeId;
          contactAttributeTypeId = ContactGeneralAttributes.ContactSource;
          contactAttributeTypeValue = othersState.contactSource;
          isEncrypted = contactDetails?.contactSourceIsEncrypted || defaultEncrypted;
          break;   
        case "annualIncome":
          contactAttributeId = contactDetails?.annualIncomeAttributeId || defaultAttributeId;
          contactAttributeTypeId = ContactGeneralAttributes.AnnualIncome;
          contactAttributeTypeValue = othersState.estimatedAnnualIncome;
          isEncrypted = contactDetails?.annualIncomeIsEncrypted || defaultEncrypted;
          break;    
        case "estimateAssest":
          contactAttributeId = contactDetails?.estimateAssestAttributeId || defaultAttributeId;
          contactAttributeTypeId = ContactGeneralAttributes.EstimateAssest;
          contactAttributeTypeValue = othersState.estimatedAssets;
          isEncrypted = contactDetails?.estimateAssestIsEncrypted || defaultEncrypted;
          break; 
        case "boardMember":
          contactAttributeId = contactDetails?.boardMemberAttributeId || defaultAttributeId;
          contactAttributeTypeId = ContactGeneralAttributes.BoardMember;
          contactAttributeTypeValue = othersState.boardMember;
          isEncrypted = contactDetails?.boardMemberIsEncrypted || defaultEncrypted;
          break; 
      }
  
      const contactOtherAttribute = {
        contactAttributeId: contactAttributeId,
        contactId: contactDetails.contactId,
        contactAttributeTypeId: contactAttributeTypeId,
        contactAttributeTypeValue: contactAttributeTypeValue === null ? "" : contactAttributeTypeValue,
        isEncrypted: isEncrypted === true ? 1 : 0,
        modifiedBy: 0,
      };
  
      contactOtherAttributes.push(contactOtherAttribute);
  }

    const handleSave = async () => {
       
    let saveSuccess = true;    

    const data = {
      contactWebStatus: {
        contactWebStatusId: othersState.webStatusId,
        contactId: contactDetails.contactId,
        webUserId: othersState.webUserID,
        contactWebStatusTypeId: othersState.webStatusTypeId,
        webUrl: othersState.webURL,
        contactWebCategoryId: othersState.webCategoryId,
        modifiedBy: 0,
      },
      contactAttributes: contactOtherAttributes,
    };

    const dateregexp = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;

    const validateAnniversaryDate = (attributeValue, regex, errorMsg) => {
      const currentDate = new Date();
      const newDate = new Date(attributeValue);

      if(attributeValue !== null){
      if (attributeValue !== "" && newDate > currentDate) {
        SBNotify({ type: "error", Msg: errorMsg });
        saveSuccess = false;
      }
      if (attributeValue !== "" && !regex.test(attributeValue)) {
        SBNotify({ type: "error", Msg: errorMsg });
        saveSuccess = false;
      }
    }
    };

    contactOtherAttributes.forEach((attribute) => {
      const { contactAttributeTypeId, contactAttributeTypeValue } = attribute;

      switch (contactAttributeTypeId) {
        case ContactGeneralAttributes.Anniversary:
          validateAnniversaryDate(
            contactAttributeTypeValue,
            dateregexp,
            "invalid Anniversary Date"
          );
          break;
      }
    });

  if (saveSuccess) {
    const response = await sbaAxios({
      url: `${insertOrUpdateContactOtherAttributes}`,
      method: "post",
      data: data,
    });
    if (response > 0) {
      SBNotify({ type: "success", Msg: "Updated Successfully" });
      redirectLinkClick();
    }
      else {
        SBNotify({ type: "warning", Msg: "Failed" });
      }
    }  

  };

  return (
    <>
      {loading ? (
        <>
          <LoadingScreen />
        </>
      ) : (
        <>
          <div id="contacts" className="mainContentData">
            <div className="bg-white m-3 p-border rounded">
              <div className="bg-white p-4">
                <div className="content-container">
                  <div className="col-lg-12 px-0">
                    <div className="row m-0">
                      <div className="col-md-3">
                        <div className="mb-4">
                          <span className="fw-medium custom-font-size">
                            Other Details
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 px-0">
                    <div className="row m-0">
                      <div className="col-md-3">
                        <div className="mb-4">
                          <span className="fw-medium mb-1">Anniversary</span>
                          <div>
                            <SBDatePicker
                              name="anniversary"
                              className="w-75"
                              value={
                                othersState.anniversary
                                  ? moment(othersState.anniversary)
                                  : null
                              }
                              placeholder={"Please Select"}
                              onChange={(date) =>
                                handleDateChange(date, "anniversary")
                              }
                            />
                          </div>
                        </div>
                        <br></br>
                        <div className="mb-4">
                          <span className="fw-medium">Estimated Assets</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="estimatedAssets"
                            Value={othersState.estimatedAssets}
                            onChange={handleChange}
                          />
                        </div>
                        <br></br>
                        <div className="mb-4">
                          <span className="fw-medium">Sits on Board</span>
                          <div>
                            <input
                              type="checkbox"
                              name="boardMember"
                              checked={othersState.boardMember === "Yes"}
                              onChange={handleCheckbox}
                            />
                          </div>
                        </div>
                        <br></br>
                      </div>
                      <div className="col-md-3">
                        <div className="mb-4">
                          <span className="fw-medium">Spouse Name</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="spouseName"
                            Value={othersState.spouseName}
                            onChange={handleChange}
                          />
                        </div>
                        <br></br>
                        <div className="mb-4">
                          <span className="fw-medium">Web User ID</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="webUserID"
                            Value={othersState.webUserID}
                            onChange={handleChange}
                          />
                        </div>
                        <br></br>
                        <div className="mb-4">
                          <span className="fw-medium">
                            Estimated Annual Income
                          </span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="estimatedAnnualIncome"
                            Value={othersState.estimatedAnnualIncome}
                            onChange={handleChange}
                          />
                        </div>
                        <br></br>
                      </div>
                      <div className="col-md-3">
                        <div className="mb-4">
                          <span className="fw-medium">Contact Source</span>

                         <div>
                         <SBADropDown
                           className="w-75"
                           data={ContactdataSource}                         
                           textField={"EnumName"}
                           valueField={"EnumValue"}
                            name="contactSource"
                            value={contactSourcevalue}
                            onChange={(e) =>
                             handleContactDropdown(e, "contactSource")
                           }
                            
                          />
                         </div>
                         </div>
                        <br></br>
                        <div className="mb-4">
                          <span className="fw-medium">Web Status</span>
                          <div>
                            <SBADropDown
                              className="w-75"
                              data={webStatusTypes}
                              textField={"ContactWebStatusTypeName"}
                              valueField={"ContactWebStatusTypeId"}
                              name="webStatusTypeId"
                              value={webStatus}
                              onChange={(e) =>
                                handleStatusDropdown(e, "webStatusTypeId")
                              }
                            />
                          </div>
                        </div>
                        <br></br>
                        <div className="mb-4">
                          <span className="fw-medium">Last Modified</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="lastModified"
                            Value={moment(othersState.modifiedDate).format(
                              "MM/DD/yyyy"
                            )}
                            disabled
                          />
                        </div>
                        <br></br>
                      </div>
                      <div className="col-md-3">
                        <div className="mb-4">
                          <span className="fw-medium">Web Category</span>
                          <div>
                            <SBADropDown
                              className="w-75"
                              data={webCategories}
                              textField={"ContactWebCategoryName"}
                              valueField={"ContactWebCategoryId"}
                              name="webCategoryId"
                              value={webCategory}
                              onChange={(e) =>
                                handleCategoryDropdown(e, "webCategoryId")
                              }
                            />
                          </div>
                        </div>
                        <br></br>
                        <div className="mb-4">
                          <span className="fw-medium">Web URL</span>
                          <input
                            className="form-control w-75"
                            type="text"
                            name="webURL"
                            Value={othersState.webURL}
                            onChange={handleChange}
                          />
                        </div>
                        <br></br>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-12 px-0">
              <UpdateorCancelButtons
                onSave={handleSave}
                onCancel={redirectLinkClick}
              />
            </div>
          </div>
        </>
      )}
      <ToastContainer/>
    </>
  );
};
